import axios from "axios";
import {
	GET_ALL_EVENT,
	SEARCH_EVENT,
	ADD_EVENT,
	UPDATE_EVENT,
	DELETE_EVENT,
} from "../../constants/endpoints";

import {
	// request
	FETCH_EVENT_REQUEST,
	ADD_EVENT_REQUEST,
	UPDATE_EVENT_REQUEST,
	DELETE_EVENT_REQUEST,

	// failure
	FETCH_EVENT_FAILURE,
	ADD_EVENT_FAILURE,
	UPDATE_EVENT_FAILURE,
	DELETE_EVENT_FAILURE,
	FETCH_USER_FAILURE,

	// success
	FETCH_EVENT_SUCCESS,
	SEARCH_EVENT_SUCCESS,
	ADD_EVENT_SUCCESS,
	UPDATE_EVENT_SUCCESS,
	DELETE_EVENT_SUCCESS,
	FETCH_USER_LOGOUT,
} from "../action-types.js";

import setAuthToken from "../../helpers/setAuthToken";
import {
	sessionInfo,
	isEmptyObject,
	showToastMessage,
} from "../../helpers/functions";

async function _handleError(error, dispatch) {
	var status = 504;

	if (!isEmptyObject(error.response)) {
		status = error.response.status;
	}

	if (status === 403) {
		await dispatch({
			type: FETCH_USER_LOGOUT,
			error: error.response.data.message,
		});
		showToastMessage(error.response.data.message, "E");
	} else if (status === 400) {
		showToastMessage(error.response.data.message, "E");
		await dispatch({
			type: FETCH_USER_FAILURE,
			error: error.response.data.message,
		});
	} else {
		showToastMessage(error.message, "E");
		await dispatch({
			type: FETCH_USER_FAILURE,
			error: error.message,
		});
	}
}
export const addEvent = (event) => async (dispatch) => {
	const sessionData = await sessionInfo();

	if (localStorage.evaLoggedIn) {
		setAuthToken(sessionData.token);
	}

	dispatch({
		type: ADD_EVENT_REQUEST,
	});

	try {
		const { data } = await axios.post(ADD_EVENT, event);

		dispatch({
			type: ADD_EVENT_SUCCESS,
			payload: data.result,
		});

		if (data.success) {
			showToastMessage(data.message, "S");
		} else {
			showToastMessage(data.message, "E");
		}

		return data.success;
	} catch (err) {
		dispatch({
			type: ADD_EVENT_FAILURE,
			error: err.message,
		});

		_handleError(err, dispatch);
	}
};

export const getAllEvents = () => async (dispatch) => {
	const sessionData = await sessionInfo();

	if (localStorage.evaLoggedIn) {
		setAuthToken(sessionData.token);
	}

	dispatch({
		type: FETCH_EVENT_REQUEST,
	});

	try {
		const response = await axios.get(GET_ALL_EVENT);

		dispatch({
			type: FETCH_EVENT_SUCCESS,
			payload: response.data.result,
		});
	} catch (err) {
		dispatch({
			type: FETCH_EVENT_FAILURE,
			error: err.message,
		});

		_handleError(err, dispatch);
	}
};

export const searchEvent = (searchData) => async (dispatch) => {
	const sessionData = await sessionInfo();

	if (localStorage.evaLoggedIn) {
		setAuthToken(sessionData.token);
	}

	dispatch({
		type: FETCH_EVENT_REQUEST,
	});

	try {
		const response = await axios.get(
			SEARCH_EVENT + `?searchText=${searchData.searchText}`
		);

		dispatch({
			type: SEARCH_EVENT_SUCCESS,
			payload: response.data.result,
		});
	} catch (err) {
		dispatch({
			type: FETCH_EVENT_FAILURE,
			error: err.message,
		});
		_handleError(err, dispatch);
	}
};

export const updateEvent = (eventInfo) => async (dispatch) => {
	const sessionData = await sessionInfo();

	if (localStorage.evaLoggedIn) {
		setAuthToken(sessionData.token);
	}

	dispatch({
		type: UPDATE_EVENT_REQUEST,
	});

	try {
		const { data } = await axios.put(UPDATE_EVENT, eventInfo);

		dispatch({
			type: UPDATE_EVENT_SUCCESS,
			payload: data.result,
		});

		if (data.success) {
			showToastMessage(data.message, "S");
		} else {
			showToastMessage(data.message, "E");
		}

		return data.success;
	} catch (err) {
		dispatch({
			type: UPDATE_EVENT_FAILURE,
			error: err.message,
		});

		_handleError(err, dispatch);
	}
};
export const deleteEvent = (event__id) => async (dispatch) => {
	const sessionData = await sessionInfo();

	if (localStorage.evaLoggedIn) {
		setAuthToken(sessionData.token);
	}

	dispatch({
		type: DELETE_EVENT_REQUEST,
	});

	try {
		const { data } = await axios.delete(
			DELETE_EVENT + `?event__id=${event__id}`
		);

		dispatch({
			type: DELETE_EVENT_SUCCESS,
			payload: data.result,
		});

		if (data.success) {
			showToastMessage(data.message, "S");
		} else {
			showToastMessage(data.message, "E");
		}

		return data.success;
	} catch (err) {
		dispatch({
			type: DELETE_EVENT_FAILURE,
			error: err.message,
		});

		_handleError(err, dispatch);
	}
};
